<template>
  <div>
    <CheckoutContainer />
  </div>
</template>

<script>
import CheckoutContainer from '@/modules/checkout'
export default {
  name: 'checkout',
  components: {
    CheckoutContainer,
  },
  metaInfo() {
    return {
      link: [{rel: 'preconnect', href: '//www.paypal.com', crossorigin: 'anonymous'}],
    }
  },
}
</script>
